import React from "react";

import styles from "./FeedbackIntro.module.scss";

import FeedbackIcon from "../../../../images/icons/user_feedback_icons/intro.svg";
export const FeedbackIntro = () => {
  return (
    <div className={styles.containerWrapper}>
      <div className={styles.container}>
        <img
          src={FeedbackIcon}
          alt="Illustration of Feedback Form"
          style={{ maxWidth: "220px" }}
        />
        <h1 className={styles.titleText}>We'd love your Feedback</h1>
        <p className={styles.description}>
          Take just a few minutes before you continue - let us know what you'd
          love, what you'd change, and how to make your experience better
          through this mandatory survey
        </p>
      </div>
    </div>
  );
};
